import TitleInput from "Components/Common/Input/TextBoxes/TitleInput/TitleInput";
import MediaUpload from "Components/Common/MediaUpload/MediaUpload";
import PdfViewer from "Components/Common/PdfViewer/PdfViewer";
import Popover from "Components/Common/Popover/Popover";
import PopoverPane from "Components/Common/Popover/PopoverPane/PopoverPane";
import { TaskTemplateStep } from "Models/Tasks/TaskTemplateStep";
import * as React from "react";
import i18n from "Translations/i18n";

interface IProps {
    items: TaskTemplateStep[];
    showItemsPopover: boolean;
    closePopover: () => void;
    onUpdate: (items: TaskTemplateStep[], descriptionFileUrl?: string) => void;
    addItem: () => void;
    popoverPaneIndex: number;
    descriptionFileUrl?: string;
}

interface IState {
    items: TaskTemplateStep[];
    showItemsPopover: boolean;
    popoverPaneIndex: number;
    descriptionFileUrl?: string;
    addItemText: string;
}

export class ChecklistInstructionsPopover extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            items: props.items,
            showItemsPopover: props.showItemsPopover,
            popoverPaneIndex: props.popoverPaneIndex,
            descriptionFileUrl: props.descriptionFileUrl,
            addItemText: props.descriptionFileUrl ? "" : i18n.t("common.addNewInstruction")
        };

        this.onMediaChanged = this.onMediaChanged.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (prevState.showItemsPopover !== nextProps.showItemsPopover
            || prevState.popoverPaneIndex !== nextProps.popoverPaneIndex) {
            partialState.showItemsPopover = !!nextProps.showItemsPopover;
            partialState.popoverPaneIndex = nextProps.popoverPaneIndex;
            partialState.addItemText = nextProps.descriptionFileUrl ? "" : i18n.t("common.addNewInstruction");
            partialState.descriptionFileUrl = nextProps.descriptionFileUrl;
        }

        if (nextProps.items && nextProps.items !== prevState.items) {
            partialState.items = nextProps.items;
        }

        return partialState;
    }

    public onDescriptionUpdated(itemIndex: number, newValue: string) {
        const items = [...this.state.items];
        items[itemIndex] = { ...items[itemIndex], description: newValue };
        this.setState({ items });
        this.props.onUpdate(items);
    }

    public onMediaChanged(itemIndex: number, state: { imageFile?: File, videoFile?: File, videoThumbnailFile?: File }) {
        const items = [...this.state.items];
        items[itemIndex] = {
            ...items[itemIndex],
            pictureUrl: state.imageFile ? URL.createObjectURL(state.imageFile) : undefined,
            videoUrl: state.videoFile ? state.videoFile !== items[itemIndex].videoFile ? URL.createObjectURL(state.videoFile) : items[itemIndex].videoUrl : state.videoThumbnailFile ? items[itemIndex].videoUrl : undefined,
            videoThumbnailUrl: state.videoThumbnailFile ? URL.createObjectURL(state.videoThumbnailFile) : undefined,
            pictureFile: state.imageFile,
            videoFile: state.videoFile,
            videoThumbnailFile: state.videoThumbnailFile
        };
        this.setState({ items });
        this.props.onUpdate(items);
    }

    public deleteItem(itemNumber: number) {
        if (this.state.descriptionFileUrl) {
            this.setState({
                descriptionFileUrl: undefined
            });

            this.props.onUpdate(this.state.items, undefined);
        }
        else {
            const localItems = this.state.items;
            localItems.splice(itemNumber - 1, 1);
            const paneIndex = localItems.length - 1;

            this.setState({
                items: localItems,
                showItemsPopover: true,
                popoverPaneIndex: paneIndex
            });

            this.props.onUpdate(localItems);
        }
    }

    public render() {
        return (
            <Popover
                title={i18n.t("checklists.checklistItem")}
                isOpen={this.state.showItemsPopover}
                onClose={this.props.closePopover}
                paneIndex={this.state.popoverPaneIndex}
                addChild={this.props.addItem}
                deleteChild={this.deleteItem}
                addItemText={this.state.addItemText}>
                {
                    this.state.items && this.state.items.length > 0 ? (
                        this.state.items.map((item, itemIndex) => (
                            <PopoverPane key={itemIndex}>
                                <MediaUpload
                                    imageUrl={item.pictureUrl}
                                    videoUrl={item.videoUrl}
                                    videoThumbnailUrl={item.videoThumbnailUrl}
                                    onChange={(state) => this.onMediaChanged(itemIndex, state)}
                                />
                                <TitleInput value={item.description} maxHeight={200} onChange={(newValue) => this.onDescriptionUpdated(itemIndex, newValue)} />
                            </PopoverPane>
                        ))
                    ) : this.state.descriptionFileUrl && (
                        <PopoverPane>
                            <PdfViewer src={this.state.descriptionFileUrl} />
                        </PopoverPane>
                    )
                }
            </Popover>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/ChecklistTemplateDetailView/ChecklistItems/ChecklistInstructionsPopover/ChecklistInstructionsPopover.tsx